/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-use-before-define */
/* eslint-disable simple-import-sort/imports */
import React, { useEffect, useState, useMemo } from 'react';
import { Typography, Grid, Button, Box, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RecommendedTestCard from '../RecommendedTestCard';
import { useHistory } from 'react-router-dom';
import { kebabCase } from 'lodash';
import { useMe } from '@orientaction/hooks';
import { apiServiceNative } from '../../utils/fetchNative';
import { getFromLS } from '@orientaction/utils';

const useStyles = makeStyles(theme => ({
  section: {
    marginTop: 0,
    marginBottom: theme.spacing(4),
    width: 1000,
    maxWidth: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: '#fff',
    padding: theme.spacing(4, 0),
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      marginLeft: 16,
      marginRight: 16,
      width: 'calc(100% - 32px)',
    },
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    color: '#18181B',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  gridContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      width: '100%',
      justifyContent: 'center',
    },
  },
  gridItem: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    '& > *': {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      width: '252px',
      maxWidth: '252px',
      flexBasis: '252px',
    },
  },
  centeredGrid: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
    },
  },
  centeredItem: {
    width: '252px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '242px',
    },
  },
  discoverButton: {
    backgroundColor: '#000A8C',
    color: 'white',
    padding: '12px 32px',
    borderRadius: 4,
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#000A8C',
      opacity: 0.9,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
  discoverButtonContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    width: '100%',
  },
}));

interface IRecommendedTestsSectionProps {
  recommendedTests: any;
  completedTestIds?: number[];
  currentUserId?: number;
  recommendedTestsOrder?: number[];
}

const RecommendedTestsSection: React.FC<IRecommendedTestsSectionProps> = ({
  recommendedTests = [],
  completedTestIds = [],
  currentUserId,
  recommendedTestsOrder = [],
}) => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { loading: loadingMe, me } = useMe();
  const [freeTests, setFreeTests] = useState<any>([]);

  const allTestsArray = recommendedTests?.data || recommendedTests || [];

  const filteredTestsArray = allTestsArray.filter((test: any) => {
    const attributes = test?.attributes || test;
    return !attributes?.isArchived && !attributes?.isDesabled;
  });

  const testsArray = useMemo(() => {
    if (!recommendedTestsOrder || recommendedTestsOrder.length === 0) {
      return filteredTestsArray;
    }

    const testsMap = new Map();
    filteredTestsArray.forEach((test: any) => {
      const testId = test?.id;
      if (testId) {
        testsMap.set(testId, test);
      }
    });

    const processedIds = new Set();

    const orderedTests: any[] = [];
    recommendedTestsOrder.forEach((orderId: number) => {
      const test = testsMap.get(orderId);
      if (test) {
        orderedTests.push(test);
        processedIds.add(orderId);
      }
    });

    filteredTestsArray.forEach((test: any) => {
      const testId = test?.id;
      if (testId && !processedIds.has(testId)) {
        orderedTests.push(test);
      }
    });

    return orderedTests;
  }, [filteredTestsArray, recommendedTestsOrder]);

  // Si pas de tests recommandés, afficher seulement le bouton sans fond blanc
  if (!testsArray || testsArray.length === 0) {
    return (
      <Box style={{ width: '100vw', marginLeft: 'calc(-50vw + 50%)', padding: '32px 0' }}>
        <div className={classes.discoverButtonContainer} style={{ marginTop: 0 }}>
          <Button className={classes.discoverButton} onClick={() => history.push('/user/tests')}>
            Découvrez tous les tests
          </Button>
        </div>
      </Box>
    );
  }

  const handleTestClick = (test: any) => {
    const testTitle = kebabCase(test?.attributes?.title || test?.title || 'test');
    const testId = test?.id || test?.data?.id;
    history.push(`/test/${testId}/${testTitle}`);
  };

  const handleDiscoverAllTests = () => {
    history.push('/tests');
  };

  const isTestCompleted = (testId: number) => {
    return completedTestIds?.includes(testId) || false;
  };

  const shouldCenterItems = false;

  const token = getFromLS('userToken') || '';

  useEffect(() => {
    const getFreeTest = async () => {
      const response = await apiServiceNative.get('/api/free-test?populate=tests');
      const testIds = response.data.attributes.tests.data.map((test: any) => test.id);
      setFreeTests(testIds);
    };
    if (token) {
      getFreeTest();
    }
  }, [token]);

  return (
    <Box style={{ backgroundColor: '#fff', width: '100vw', marginLeft: 'calc(-50vw + 50%)', padding: '0 0 32px 0' }}>
      <Box className={classes.section}>
        <Typography className={classes.title}>
          Découvrez les tests qui pourraient vous intéresser
        </Typography>

      {shouldCenterItems ? (
        <div className={classes.centeredGrid}>
          {testsArray.map((test: any, index: number) => (
            <div key={test?.id || index} className={classes.centeredItem}>
              <RecommendedTestCard
                test={test}
                isTestDone={isTestCompleted(test?.id)}
                onClick={() => handleTestClick(test)}
                me={me}
                freeTests={freeTests}
              />
            </div>
          ))}
        </div>
      ) : (
        <Grid
          container={true}
          spacing={3}
          className={classes.gridContainer}
          justifyContent={testsArray.length <= 3 ? 'center' : 'flex-start'}>
          {testsArray.map((test: any, index: number) => (
            <Grid item xs={12} sm={6} md={3} key={test?.id || index} className={classes.gridItem}>
              <RecommendedTestCard
                test={test}
                isTestDone={isTestCompleted(test?.id)}
                onClick={() => handleTestClick(test)}
                me={me}
                freeTests={freeTests}
              />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Bouton Découvrez tous les tests */}
      <div className={classes.discoverButtonContainer}>
        <Button className={classes.discoverButton} onClick={() => history.push('/user/tests')}>
          Découvrez tous les tests
        </Button>
        </div>
      </Box>
    </Box>
  );
};

export default RecommendedTestsSection;
